export const localhost = "https://hr.rainscales.com.vn";
// export const localhost = 'https://hr-v2-test.dri.io.vn'
// export const localhost = "http://10.2.21.89:2005";
